export const easeOutQuart = 'cubic-bezier(0.165, 0.84, 0.44, 1)';
export const easeInOutQuart = 'cubic-bezier(0.77, 0, 0.175, 1)';



/** WEBPACK FOOTER **
 ** ./src/theme/easeFunctions.js
 **/